import { render, staticRenderFns } from "./RuleTabPanel.vue?vue&type=template&id=c437bfe2&scoped=true&"
import script from "./RuleTabPanel.vue?vue&type=script&lang=ts&"
export * from "./RuleTabPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c437bfe2",
  null
  
)

export default component.exports